<template>
	<div class="search-results no-results component-padding-m bg-color-white fadeInSimple">
	    <div class="row">
	        <div class="col-7">
	            <h1 class="type-bold add-top-padding no-top-margin add-small-bottom-margin">No Results</h1>
	            <div class="type-large color-silver-darkest">
	                <p class="type-large add-x-small-bottom-margin">Continue your search above, or try:</p>
	                <ul class="padding-left-l">
	                    <li class="no-top-margin">Checking your spelling</li>
	                    <li class="no-top-margin">Using more general search terms</li>
	                </ul>
	            </div>
	        </div>

	    </div>
	</div>
</template>

<script>

export default {
  name: 'GlobalSearchNoResults',
}

</script>


// WEBPACK FOOTER //
// resources/assets/js/components/GlobalSearchNoResults.vue